module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friend"
  }, [_c('div', {
    staticClass: "title-1"
  }, [_c('mu-icon', {
    attrs: {
      "value": "assignment_ind"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sync phone contacts!")]), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "chevron_right"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('mu-tabs', [_c('mu-tab', {
    attrs: {
      "value": "tab1",
      "icon": "person_add",
      "title": "New Friend",
      "iconClass": "i-1",
      "titleClass": "t-1",
      "disabled": ""
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab2",
      "icon": "people",
      "title": "Groups",
      "iconClass": "i-2",
      "titleClass": "t-1",
      "disabled": ""
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tab3",
      "icon": "person",
      "title": "Official Accour",
      "iconClass": "i-3",
      "titleClass": "t-1",
      "disabled": ""
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mac"
  }, [_c('mu-list-item', {
    attrs: {
      "title": "Mac",
      "describeLine": 1,
      "disableRipple": true
    }
  }, [_c('mu-avatar', {
    attrs: {
      "slot": "leftAvatar",
      "icon": "folder",
      "color": "#2e2c6b",
      "backgroundColor": "#eee",
      "size": 40,
      "iconSize": 20
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "describe"
    },
    slot: "describe"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .5)"
    }
  }, [_vm._v("You are my destiny")])]), _vm._v(" "), _c('div', {
    staticClass: "item-right",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('span', {
    staticClass: "time"
  }, [_vm._v("20:34")])])], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('mu-list', _vm._l((_vm.friends), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('mu-list-item', {
      attrs: {
        "title": item.name,
        "disableRipple": true
      },
      on: {
        "click": function($event) {
          return _vm.showPersonindex(item._id)
        }
      }
    }, [_c('mu-avatar', {
      attrs: {
        "slot": "leftAvatar",
        "src": item.avatar
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "chat_bubble"
      },
      slot: "right"
    })], 1), _vm._v(" "), _c('mu-divider', {
      attrs: {
        "inset": ""
      }
    })], 1)
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-2"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .8)"
    }
  }, [_vm._v("My Device")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-3"
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, .8)"
    }
  }, [_vm._v("My Friends")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23cd8c7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/friends/friends.vue
// module id = 496
// module chunks = 1